import styled from "styled-components"
import { theme } from "Theme"
const { colors } = theme

const FooterSection = styled.footer`
  background-color: ${(props) => (props.transparentFooter ? colors.transparent : colors.black.base)};
  color: ${(props) => (props.transparentFooter ? colors.black.light : colors.white.base)};
  ${(props) => (props.transparentFooter ? `border-top: 1px solid ${colors.white.grey}` : ``)};
  text-align: center;
  height: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
    // min-height: 322px;
    // padding-bottom: 0px;
  }
`

export default FooterSection
